import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  Injector,
  Input,
} from '@angular/core';
import { CRMIntegrationsService } from '../../../services/crm-integrations.service';
import { publicMethods } from '../../../globals';

@Component({
    selector: 'wizard-crm-enrichment',
    templateUrl: './wizard-crm-enrichment.component.html',
    styleUrl: './wizard-crm-enrichment.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class WizardCrmEnrichmentComponent {
  @Input() stepData: Record<string, any>;

  crmService = inject(CRMIntegrationsService);
  pubMethods = inject(publicMethods);
  injector = inject(Injector);

  crmType: string = '';
  enableEnrichment = false;
  crmObjectID = computed(() => {
    return this.crmService.configCRMSelectedObjectId();
  });
  CRM_OBJECT_TYPE = 'crm_object_type';

  ngOnInit() {
    this.crmType = this.crmService.configCRMType();
    this.getStepActionContent();
  }

  getStepActionContent(): void {
    this.crmService
      .getCRMExistingState({
        actionType: this.CRM_OBJECT_TYPE,
        objectId: this.crmObjectID(),
      })
      .subscribe(data => {
        this.handleExistingState(data);
        this.crmService.getCRMConfigStepStatus(this.stepData.stepType);
      });
  }

  handleExistingState(data: Record<string, any>): void {
    if (!this.pubMethods.hasData(data)) return;

    const objectData = this.crmObjectID() ? data : data[0]; //obj or arr
    this.enableEnrichment = objectData.enrichEnabled;
    this.crmService.configCRMSelectedObjectId.update(() => {
      return objectData.id;
    });
  }

  updateChoiceAndGetStatus(): void {
    const reqBody = { enrichEnabled: this.enableEnrichment };

    this.crmService
      .updateCRMStepActionContent({
        updateActionType: this.CRM_OBJECT_TYPE,
        params: reqBody,
        objectId: this.crmService.configCRMSelectedObjectId(),
        updateMethod: 'patch',
      })
      .subscribe(res => {
        if (res.ok) {
          this.crmService.getCRMConfigStepStatus(this.stepData.stepType);
        }
      });
  }
}
